interface BeckOnlineCampaignModule {
    produktURL: string;
    haupttitel: string;
}

export async function initBeckOnlineModules(): Promise<void> {
    const container = document.getElementById('beck-online-modules-container');
    if (!container) {
        return;
    }

    const productId = container.dataset.productid;
    if (!productId) {
        return;
    }

    const spinner = document.getElementById('beck-online-modules-spinner');
    const heading = document.getElementById('beck-online-modules-heading');
    const list = document.getElementById('beck-online-modules-list');
    const buttons = document.getElementById('beck-online-modules-buttons');

    const hideContainer = () => {
        if (spinner) spinner.style.display = 'none';
        container.style.display = 'none';
    };

    try {
        const response = await fetch(
            `/umbraco/api/ProduktdetailApi/GetBeckOnlineCampaignModules?productId=${productId}`
        );

        if (!response.ok) {
            hideContainer();
            return;
        }

        const modules: BeckOnlineCampaignModule[] = await response.json();

        if (spinner) spinner.style.display = 'none';

        if (!modules || modules.length === 0 || !list) {
            container.style.display = 'none';
            return;
        }

        const utmParams =
            'utm_source=beck-shop.de&utm_medium=referral&utm_campaign=bs_clickout-online-only&em_src=cp&em_cmp=beck-shop.de_ref_clickout-online-only';

        modules.forEach((module) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            const separator = module.produktURL.includes('?') ? '&' : '?';
            a.href = `${module.produktURL}${separator}${utmParams}`;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            a.textContent = module.haupttitel;
            li.appendChild(a);
            list.appendChild(li);
        });

        heading?.classList.remove('hide');
        list.classList.remove('hide');
        buttons?.classList.remove('hide');
    } catch {
        hideContainer();
    }
}
